import { EditForm } from "./AccountDetailsContainer";

export const formConfig: {
  label: string;
  field: keyof EditForm;
}[] = [{
  label: "Name",
  field: "fullName"
}, {
  label: "Email",
  field: "email"
}, {
  label: "Label or Manager",
  field: "labelOrManager"
}, {
  label: "Phone",
  field: "phone"
}, {
  label: "Address",
  field: "address"
}];